<template>
  <div class="rules-block rules">
    <draggable :rules="rulesList" :types="typesList" :parameters="paramsList" :operators="opsList" :actions="actionsList">
    </draggable>
    <div class="pull-right">
      <v-select v-if="templatesList.length > 0" :items="templatesList" item-text="name" return-object v-model="selectedTemplate" class="d-inline"></v-select>
      <v-btn icon @click="create"><v-icon color="#33cc33">mdi-plus-thick</v-icon></v-btn>
      <v-btn @click="save">Save</v-btn>
    </div>
  </div>
</template>

<script>
import draggable from './filtering-rules-tree'

export default {
  components: { draggable },
  name: "filtering-rules",
  props: {
    submit: {
      type: Function | String,
      default: () => {}
    },
    rules: {
      type: Array | String,
      default: () => { return []; }
    },
    parameters: {
      type: Array | String,
      default: () => { return [ 'Type', 'Duration', 'Min HR', 'Max HR', 'Avg HR' ]; }
    },
    operators: {
      type: Array | String,
      default: () => { return [ '==', '!=', '>', '>=', '<', '<=' ]; }
    },
    types: {
      type: Array | String,
      default: () => { return []; }
    },
    actions: {
      type: Array | String,
      default: () => { return [ 'Accept', 'Reject' ]; }
    },
    templates: {
      type: Array | String,
      default: () => { return []; }
    }
  },
  data() {
    return {
      rulesList: [],
      typesList: [],
      paramsList: [],
      opsList: [],
      actionsList: [],
      templatesList: [],

      itemId: 1,
      selectedTemplate: null,
    };
  },
  methods: {
    loadRules() {
      if (typeof(this.rules) !== 'string') {
        return this.onRulesLoaded(this.rules);
      }

      const self = this;
      axios.get(this.rules).then(r => {
        this.onRulesLoaded(r.data);
      }).catch(e => {
        console.error(e);
        self.toast('Can not get list of rules because of server error.', 'error');
      });
    },
    loadTypes() {
      if (typeof(this.types) !== 'string') {
        this.typesList = this.types;
        return;
      }

      const self = this;
      axios.get(this.types).then(r => {
        this.typesList = r.data;
      }).catch(e => {
        console.error(e);
        self.toast('Can not get list of types because of server error.', 'error');
      });
    },
    loadParameters() {
      if (typeof(this.parameters) !== 'string') {
        this.paramsList = this.parameters;
        return;
      }

      const self = this;
      axios.get(this.parameters).then(r => {
        this.paramsList = r.data;
      }).catch(e => {
        console.error(e);
        self.toast('Can not get list of parameters because of server error.', 'error');
      });
    },
    loadOperators() {
      if (typeof(this.operators) !== 'string') {
        this.opsList = this.operators;
        return;
      }

      const self = this;
      axios.get(this.operators).then(r => {
        this.opsList = r.data;
      }).catch(e => {
        console.error(e);
        self.toast('Can not get list of operators because of server error.', 'error');
      });
    },
    loadActions() {
      if (typeof(this.actions) !== 'string') {
        this.actionsList = this.actions;
        return;
      }

      const self = this;
      axios.get(this.actions).then(r => {
        this.actionsList = r.data;
      }).catch(e => {
        console.error(e);
        self.toast('Can not get list of actions because of server error.', 'error');
      });
    },
    loadTemplates() {
      if (typeof(this.templates) !== 'string') {
        return this.onTemplatesLoaded(this.templates);
      }

      const self = this;
      axios.get(this.templates).then(r => {
        this.onTemplatesLoaded(r.data);
      }).catch(e => {
        console.error(e);
        self.toast('Can not get list of templates because of server error.', 'error');
      });
    },

    save() {
      (typeof(this.submit) !== 'string') ? this.submit(this)
          : this.postToUrl(this.submit, { rules: this.rulesList }).then(r => {
            if (r.data.error) {
              this.toast(r.data.error, 'error');
            } else {
              this.toast('Rules saved.');
            }
          }).catch(e => {
            console.error(e);
            this.toast('Server error occurred. Retry later.', 'error');
          });
    },
    postToUrl(url, data) {
      return axios.post(url, data);
    },

    create() {
      if (!Array.isArray(this.templatesList) || this.templatesList.length < 1 || !this.selectedTemplate) {
        this.rulesList.push(this.initRuleset({}));
      } else {
        let set = Array.isArray(this.selectedTemplate) ? this.selectedTemplate : this.selectedTemplate.rules;
        for (let entry of set) this.rulesList.push(this.initRuleset(JSON.parse(JSON.stringify(entry))));
      }
    },
    onRulesLoaded(data) {
      this.rulesList = data;
      for (let item of this.rulesList) this.initRuleset(item);
      // this.itemId = this.getMaxItemId(this.rulesList, this.itemId);
    },
    onTemplatesLoaded(data) {
      this.templatesList = data;
      if (Array.isArray(this.templatesList) && this.templatesList.length > 0)
        this.selectedTemplate = this.templatesList.find(e => true);
    },
    initRuleset(rule) {
      console.debug("initRuleset()", rule);

      if (!rule.hasOwnProperty('rules')) rule.rules = [];
      if (!rule.hasOwnProperty('parameter')) rule.parameter = this.getArrayFirstKey(this.paramsList);
      if (!rule.hasOwnProperty('operator')) rule.operator = this.getArrayFirstKey(this.opsList);
      if (!rule.hasOwnProperty('action')) rule.action = this.getArrayFirstKey(this.actionsList);
      for (let entry of rule.rules) this.initRuleset(entry, this.itemId++);

      rule.id = this.itemId++;
      return rule;
    },
    getMaxItemId(rules, id) {
      for (let item of rules) {
        id = Math.max(id || 0, item.id || 0, this.getMaxItemId(item.rules, id));
      }
      return id;
    },
    getArrayFirstKey(arr) {
      const result = arr.find(e => true);
      return result.value ? result.value : result;
    },

    toast(message, type) {
      const self = this.$swal;
      self.fire({
        text: message,
        icon: type || 'success',
        toast: true,
        showConfirmButton: false,
        position: 'top-end',
        timer: 1500,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', self.stopTimer)
          toast.addEventListener('mouseleave', self.resumeTimer)
        }
      });
    },
    notify(id) {
      this.$el.dispatchEvent(new CustomEvent(id, { bubbles: true, detail: this }));
    }

  },
  mounted() {
    this.loadRules();
    this.loadParameters();
    this.loadOperators();
    this.loadTypes();
    this.loadActions();
    this.loadTemplates();
  }
}
</script>
